export default "__VITE_ASSET__BZERfHwX__"